// libraries
import * as THREE from 'three';
import CameraControlsLib from 'camera-controls';

/** MainObject */
export const MAIN_OBJECT = 'MainObject';

/** allHidden */
export const ALL_HIDDEN = 'allHidden';

/** 기본 테이블 사이즈 */
export const DEFAULT_PAGE_SIZE = 20;

/** 일자 포맷 */
export const DATE_FORMAT = 'YYYY-MM-DD';

/** 일자 영어 요일 */
export const weekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

export const ACTIVE_EMISSIVE_COLOR = '#c49812';
export const ACTIVE_EMISSIVE_COLOR_POI = '#32C53C';
export const ACITVE_EMISSIVE_INTENSITY = 5;

export const GRAVITY_Y = 3200;
export const PLAYER_MOVE_SPEED = 500;

export const PLAYER_HALF_HEIGHT = 32;
export const PLAYER_RADIUS = 40;

export const NONE_TYPE = 'NONE';

/** 드로잉 히스토리 최대 갯수 */
export const DRAWING_HISTORY_MAX = 12;

/** 드로잉 모드 */
export const DRAWING_MODE = {
  DRAWING: 'DRAWING',
  RECTANGLE: 'RECTANGLE',
  TEXT: 'TEXT',
  ERASER: 'ERASER',
  UNDO: 'UNDO',
  REDO: 'REDO'
};

/** 드로잉 텍스트 정렬 */
export const DRAWING_TEXT_ALIGN = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

/** 드로잉 사이즈 */
export const DRAWING_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

export const DRAWING_LINE_SIZE = {
  SMALL: 3,
  MEDIUM: 6,
  LARGE: 10
};

/** 드로잉 지우개 사이즈 */
export const DRAWING_REMOVE_SIZE = {
  SMALL: 10,
  MEDIUM: 20,
  LARGE: 30
};

/** 드로잉 칼라 */
export const DRAWING_COLORS = [
  { key: 'red', value: '#ff0000', isSelected: false },
  { key: 'blue', value: '#000dff', isSelected: false },
  { key: 'yellow', value: '#f6ff00', isSelected: false },
  { key: 'black', value: '#000000', isSelected: true },
  // { key: 'gray', value: '#969696', isSelected: false },
  { key: 'white', value: '#ffffff', isSelected: false }
];

/** 카메라 초기 셋팅 */
export const initCameraConfig = {
  enableZoom: true,
  enableRotate: true,
  enablePan: true,
  minDistance: 2.220446049250313e-16,
  maxDistance: Infinity,
  minPolarAngle: 0,
  maxPolarAngle: Math.PI,
  azimuthAngle: Math.PI / 20,
  minAzimuthAngle: -Infinity,
  maxAzimuthAngle: Infinity,
  mouseButtons: {
    left: CameraControlsLib.ACTION.ROTATE,
    right: CameraControlsLib.ACTION.TRUCK, 
    middle: CameraControlsLib.ACTION.DOLLY,
    wheel: CameraControlsLib.ACTION.DOLLY
  },
  touches: {
    one: CameraControlsLib.ACTION.TOUCH_ROTATE,
    two: CameraControlsLib.ACTION.TOUCH_DOLLY_TRUCK,
    three: CameraControlsLib.ACTION.TOUCH_TRUCK
  },
  enabled: true,
  minZoom: 0.01,
  maxZoom: 1.7976931348623157e308,
  smoothTime: 0.25,
  draggingSmoothTime: 0.125,
  dollySpeed: 1,
  truckSpeed: 2,
  dollyToCursor: false,
  verticalDragToForward: false,
  target: [272.24310779571533, 135.5636215209962, -462.288076415658],
  position: [686.6912399310432, 135.56362152099638, 2154.434445608011],
  zoom: 1,
  focalOffset: [0, 0, 0],
  target0: [0, 0, 0],
  position0: [12, 12, 12.000000000000002],
  zoom0: 1,
  focalOffset0: [0, 0, 0]
};

/** 파주현장 빌딩 리스트 */
export const bundangBuildingList = [
  {
    buildingCode: 'D0309',
    floorList: [
      'F16',
      'F15',
      'F14',
      'F13',
      'F12',
      'F11',
      'F10',
      'F09',
      'F08',
      'F07',
      'F06',
      'F05',
      'F04',
      'F03',
      'F02',
      'F01',
      'F00',
      'B00',
      'B01',
      'B02',
      'B03'
    ],
    minFloor: 'B03',
    maxFloor: 'F16',
    floorLength: 21,
    floorOptions: [
      {
        id: '0e2826a2-bd78-4f56-a9a6-434b82d55fd7',
        key: MAIN_OBJECT,
        value: MAIN_OBJECT,
        label: '전체'
      },
      {
        id: '97bf47b3-30ce-46aa-b367-069fe0d0ca0e',
        key: 'F16',
        value: 'F16',
        label: 'F16'
      },
      {
        id: '415620e0-b97d-4161-b9fd-9ba661f6ca48',
        key: 'F15',
        value: 'F15',
        label: 'F15'
      },
      {
        id: '6a97f6d6-27b6-4e15-ad6a-66d40a72fdaa',
        key: 'F14',
        value: 'F14',
        label: 'F14'
      },
      {
        id: 'b9f378af-62d9-42f0-bc1c-13f406e8ff2a',
        key: 'F13',
        value: 'F13',
        label: 'F13'
      },
      {
        id: '03bb4ef4-e877-4181-b83c-ceda890a870e',
        key: 'F12',
        value: 'F12',
        label: 'F12'
      },
      {
        id: '3398978b-f5fd-4c65-96f6-6d3fba4df149',
        key: 'F11',
        value: 'F11',
        label: 'F11'
      },
      {
        id: 'd327dcbf-efdf-49c5-a3fc-5dde305a5f89',
        key: 'F10',
        value: 'F10',
        label: 'F10'
      },
      {
        id: '75b06995-d256-4bf2-b6f5-65753240a036',
        key: 'F09',
        value: 'F09',
        label: 'F09'
      },
      {
        id: '330cd33d-7d8b-4a34-bff2-fa56ea70b032',
        key: 'F08',
        value: 'F08',
        label: 'F08'
      },
      {
        id: '6362bfdb-86ab-49ed-81c5-9ce381f5abd3',
        key: 'F07',
        value: 'F07',
        label: 'F07'
      },
      {
        id: '22a78390-0456-4939-9665-315f90cdd6c9',
        key: 'F06',
        value: 'F06',
        label: 'F06'
      },
      {
        id: '9f1319e5-5442-44a5-98c2-23373b891309',
        key: 'F05',
        value: 'F05',
        label: 'F05'
      },
      {
        id: 'f9b0ccf2-29b1-4fd1-a33e-520cebf2fb7f',
        key: 'F04',
        value: 'F04',
        label: 'F04'
      },
      {
        id: 'b0e49696-f7e2-4298-863b-a0250fa83f65',
        key: 'F03',
        value: 'F03',
        label: 'F03'
      },
      {
        id: '4d109149-0316-4c2d-8967-ac5e694aa210',
        key: 'F02',
        value: 'F02',
        label: 'F02'
      },
      {
        id: 'ad5bbb61-fd00-499b-9127-e7063b2f2976',
        key: 'F01',
        value: 'F01',
        label: 'F01'
      },
      {
        id: '3be885c8-24d8-4ead-a37a-56dc7e8c6302',
        key: 'F00',
        value: 'F00',
        label: 'F00'
      },
      {
        id: 'bff59bb4-280d-4310-ab08-398c69899538',
        key: 'B01',
        value: 'B01',
        label: 'B01'
      },
      {
        id: '5675d41a-1940-4c14-8f38-0fc30f648cd7',
        key: 'B02',
        value: 'B02',
        label: 'B02'
      },
      {
        id: '0878a799-afdc-4eac-96d6-966df80dbfe8',
        key: 'B03',
        value: 'B03',
        label: 'B03'
      }
    ],
    currentFloor: MAIN_OBJECT
  }
];
